import { Text, spacing, zIndex, ZIndexLevel } from '@thg-commerce/gravity-theme'

import { css } from '../../theme'

export const FlyoutMenuStyle = css`
  position: fixed;
  top: 0;
  bottom: 0;
  width: ${(props) => props.theme.patterns.header.flyout.width};
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  overflow-x: hidden;
`

export const FlyoutFooterStyle = css`
  background-color: ${(props) =>
    props.theme.patterns.header.subNavigation.mobile.footerBackgroundColor};
  flex-grow: 1;
  padding-top: ${spacing(1)};
`

export const FlyoutHeaderWrapperStyle = css`
  position: sticky;
  top: 0;
  ${zIndex(ZIndexLevel.High)};
`

export const FlyoutHeaderStyle = css`
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  box-sizing: border-box;
`

export const FlyoutHeaderContentStyle = css`
  display: flex;
  justify-content: space-between;
  padding: ${spacing(1)};
  background-color: ${(props) => props.theme.colors.palette.greys.white};
  border-bottom: ${(props) =>
    props.theme.patterns.header.navigation.borderBottom};
`
export const HeaderButtonCommonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.palette.brand.base};
  border: 2px solid transparent;
  height: 40px;
  min-width: 40px;

  svg,
  path {
    fill: ${(props) =>
      props.theme.patterns.header.navigation.homeIconColor ||
      props.theme.colors.palette.brand.base};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const HeaderButtonStyle = css`
  ${Text('bodyText', 'default')}
  ${HeaderButtonCommonStyles}
`

export const HeaderButtonTextStyle = css`
  display: block;
  padding-right: ${spacing(1)};

  color: ${(props) =>
    props.theme.patterns?.header.navigation.mobileLinkFont.textColor};
`
